module.exports = __webpack_public_path__ + "static/media/solihuill-hs2.307a0f7b.jpg";